angular.module("ShareWithApp").run(["$http", "$rootScope", "$routeParams", "$location", "$mdDialog",
    function ($http, $rootScope, $routeParams, $location, $mdDialog) {
        $http.defaults.xsrfCookieName = "csrftoken";
        $http.defaults.xsrfHeaderName = "X-CSRFToken";
    }]
);

